'use client';
import styles from './Prices.module.scss';
import { useTranslation } from '@/app/i18n/client';
import first from 'lodash/first';
import isEmpty from 'lodash/isEmpty';
import useUser from '@/grandus-lib/hooks/useUser';
import VAT from '@/utils/vat';
import get from 'lodash/get';

const Prices = ({ product, className = '', isSimple = false }) => {
  const { t } = useTranslation();

  const { user } = useUser();
  const isVatPrimary = VAT.isVatPrices(user);

  const size = first(product?.store);
  const suffix = !isEmpty(size) ? `/ ${size?.name}` : '';

  const priceKey = isVatPrimary ? 'priceWithoutVatFormatted' : 'priceFormatted';


  if (isSimple) {
    return (
      <div className={`${styles.prices} ${className}`}>
        <div className={`${styles.final}`}>
          <span>{get(product, ['finalPriceData', priceKey])}</span> {suffix} <br />
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.prices} ${styles.pricesFull} ${className}`}>
      <div className={`${styles.final} ${product.discount ? styles.discounted : ''}`}>
        <span>{get(product, ['finalPriceData', priceKey])}</span> {suffix} <br />
        {isVatPrimary ? t('price.vat_not_included') : t('price.vat_included')}
      </div>

      {product.discount && product?.priceData?.priceFormatted ?
        <div className={styles.standard}>
          {get(product, ['standardPriceData', priceKey])} {suffix}
        </div> : null
      }
    </div>
  );
};
export default Prices;
